import { ORDER_STATUS_OPTIONS } from "./OrderService";

const safeStr = (v: any) => (v == null ? "" : String(v));

export const normalizeOrderStatus = (status?: string | number): number => {
  if (status == null || status === "") return 1;
  const n = Number(status);
  if (!Number.isNaN(n)) return n;
  const found = ORDER_STATUS_OPTIONS.find(
    (s) => s.label.toLowerCase() === safeStr(status).toLowerCase()
  );
  return found?.value ?? 1;
};

export const orderStatusLabel = (status?: string | number): string => {
  const found = ORDER_STATUS_OPTIONS.find(
    (s) => s.value === normalizeOrderStatus(status)
  );
  return found?.label || safeStr(status) || "Ordered";
};

export const orderStatusColor = (
  status?: string | number
): "success" | "error" | "warning" | "info" | "default" => {
  const label = orderStatusLabel(status).toLowerCase();
  switch (label) {
    case "delivered":
      return "success";
    case "cancelled":
    case "payment failed":
      return "error";
    case "returned":
    case "partial delivered":
      return "warning";
    case "shipped":
    case "processing":
    case "confirmed":
      return "info";
    default:
      return "default";
  }
};
